import { Pipe, PipeTransform } from '@angular/core';
import { Pedido } from 'src/app/models/pedido';
import * as removeAccents from 'remove-accents';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'searchPedidosSalvos'
})
export class SearchPedidosSalvosPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: Pedido[], filtroPesquisa?: string): any {
    let resultFilter = value;
    if (!filtroPesquisa) {
      return resultFilter;
    } else {
      if (filtroPesquisa) {
        resultFilter = resultFilter.filter(s => {
          return (
            s.pedidoId.toLocaleString().toLocaleLowerCase().includes(filtroPesquisa) ||
            removeAccents(this.datePipe.transform(s.dataCadastro, 'dd/MM/yyyy')).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
            removeAccents(s.produtoDescricao).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
            removeAccents(s.valor.toString()).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
            removeAccents(s.descricaoSituacao).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase())
            // removeAccents(this.datePipe.transform(s.dataLiberacao, 'dd/MM/yyyy')).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase())
          );
        });
      }
    }

    return resultFilter;
  }

}
